<template>
  <div class="has-header has-footer pb-50" id="study-activity-activityId">
    <div class="container-style">
      <studyFeatureHeader></studyFeatureHeader>
      <b-row class="mt-20" v-if="currentView == 'scheduled-activities' || currentView == 'activity-order'">
        <b-col cols="4">
          <h5><b>Activities</b></h5>
        </b-col>
        <b-col cols="8" class="text-right">
          <b-btn class="fs-12 mr-10 btnBgColor" size="lg" @click="showFormsForSelection()">Create a Packet</b-btn>
          <b-btn class="fs-12 mr-10 btnBgColor" size="lg" @click="selectActivityFromLibrary()">
            Select From Library
          </b-btn>
          <b-btn variant="primary" class="btn fs-12 create-activity btn-primary" size="lg" v-on:click="createActivity()">
            <img class="create-activity-img" src="static/img/activity-configurator/Create-Activity.svg" />
            <span class="create-activity-text">Create New</span>
          </b-btn>
        </b-col>
      </b-row>
      <b-row class="pl-12">
        <b-col cols="3" class="p-0">
          <input type="text" class="form-control mb-10 br-25 search-field" placeholder="Search" v-model="searchTerm" @keyup.enter="searchFormName(searchTerm)" />
        </b-col>
      </b-row>
      <div class="" id="scheduled-activities" v-if="currentView == 'scheduled-activities'">
        <hr />
        <div class="row">
          <div :class="previewSelectedId ? 'col-md-6 pl-0' : 'col-md-12 p-0'">
            <div class="container-fluid">
              <div class="row">
                <div :class="previewSelectedId ? 'col-md-6 pl-0' : 'col-md-8 p-0'">
                  <h6>
                    <b>Scheduled Activities</b>
                    <span class="badge badge-secondary ml-5">
                      {{ allActivities.length }}
                    </span>
                  </h6>
                </div>
                <div :class="previewSelectedId ? 'col-md-3 pl-0' : 'col-md-2 p-0'" class="text-right">
                  <b-btn v-if="activities && activities.length > 1" class="fs-12 mr-10 btnBgColor" size="md" @click="changeActivityOrder">
                    Change Order
                  </b-btn>
                </div>
                <div :class="previewSelectedId ? 'col-md-3 pl-0' : 'col-md-2 p-0'" class="text-right">
                  <b-form-select v-model="selectedShowOption" :options="scheduleFormOptions" class="mb-3 fs-12" size="sm" @change="showActivities" />
                </div>
              </div>
            </div>
            <template v-if="activities && activities.length">
              <div class="wrapper position-relative">
                <table class="create-edit-packet-page__order-table mt-20" style="width: 100%">
                  <colgroup>
                    <col style="width: 4%" />
                  </colgroup>
                  <colgroup>
                    <col style="width: 16%" />
                  </colgroup>
                  <colgroup>
                    <col style="width: 13%" />
                  </colgroup>
                  <colgroup>
                    <col style="width: 13%" />
                  </colgroup>
                  <colgroup>
                    <col style="width: 12%" />
                  </colgroup>
                  <colgroup>
                    <col style="width: 10%" />
                  </colgroup>
                  <colgroup>
                    <col style="width: 5%" />
                  </colgroup>
                  <colgroup>
                    <col style="width: 6%" />
                  </colgroup>
                  <colgroup>
                    <col style="width: 8%" />
                  </colgroup>
                  <colgroup>
                    <col style="width: 8%" />
                  </colgroup>
                  <colgroup>
                    <col style="width: 11%" />
                  </colgroup>
                  <colgroup>
                    <col style="width: 2%" />
                  </colgroup>
                  <thead>
                    <tr>
                      <th class="p-0 ml-5 w-45"></th>
                      <th class="p-0 cursor-pointer w-160" @click="toggleSortForUnselectedFormData('name')">
                        Name
                        <span class="sortUp" @click="sortUnselectedFormData('name', 'ASC')">
                          <i class="fa fa-angle-up" aria-hidden="true"></i>
                        </span>
                        <span class="sortDown" @click="sortUnselectedFormData('name', 'DESC')">
                          <i class="fa fa-angle-down" aria-hidden="true"></i>
                        </span>
                      </th>
                      <th class="p-0 cursor-pointer w-145" @click="toggleSortForUnselectedFormData('name')">
                        Type
                        <span class="sortUp" @click="sortUnselectedFormData('name', 'ASC')">
                          <i class="fa fa-angle-up" aria-hidden="true"></i>
                        </span>
                        <span class="sortDown" @click="sortUnselectedFormData('name', 'DESC')">
                          <i class="fa fa-angle-down" aria-hidden="true"></i>
                        </span>
                      </th>
                      <template v-if="!previewSelectedId">
                        <th class="p-0 w-130">Scheduled</th>
                        <th class="p-0 cursor-pointer w-136" @click="toggleSortForUnselectedFormData('createdBy')">
                          Created By
                          <span class="sortUp" @click="sortUnselectedFormData('name', 'ASC')">
                            <i class="fa fa-angle-up" aria-hidden="true"></i>
                          </span>
                          <span class="sortDown" @click="sortUnselectedFormData('name', 'DESC')">
                            <i class="fa fa-angle-down" aria-hidden="true"></i>
                          </span>
                        </th>
                        <th class="p-0 cursor-pointer w-113" @click="toggleSortForUnselectedFormData('groupName')">
                          Group
                          <span class="sortUp" @click="sortUnselectedFormData('name', 'ASC')">
                            <i class="fa fa-angle-up" aria-hidden="true"></i>
                          </span>
                          <span class="sortDown" @click="sortUnselectedFormData('name', 'DESC')">
                            <i class="fa fa-angle-down" aria-hidden="true"></i>
                          </span>
                        </th>
                        <th class="p-0 cursor-pointer w-56" @click="toggleSortForUnselectedFormData('questionCount')">
                          Steps
                          <span class="sortUp" @click="sortUnselectedFormData('name', 'ASC')">
                            <i class="fa fa-angle-up" aria-hidden="true"></i>
                          </span>
                          <span class="sortDown" @click="sortUnselectedFormData('name', 'DESC')">
                            <i class="fa fa-angle-down" aria-hidden="true"></i>
                          </span>
                        </th>
                        <th class="p-0 cursor-pointer w-68" @click="toggleSortForUnselectedFormData('timeToComplete')">
                          Duration
                          <span class="sortUp" @click="sortUnselectedFormData('name', 'ASC')">
                            <i class="fa fa-angle-up" aria-hidden="true"></i>
                          </span>
                          <span class="sortDown" @click="sortUnselectedFormData('name', 'DESC')">
                            <i class="fa fa-angle-down" aria-hidden="true"></i>
                          </span>
                        </th>
                        <th class="p-0 cursor-pointer w-80" @click="toggleSortForUnselectedFormData('type')">
                          Languages
                          <span class="sortUp" @click="sortUnselectedFormData('name', 'ASC')">
                            <i class="fa fa-angle-up" aria-hidden="true"></i>
                          </span>
                          <span class="sortDown" @click="sortUnselectedFormData('name', 'DESC')">
                            <i class="fa fa-angle-down" aria-hidden="true"></i>
                          </span>
                        </th>
                        <th class="p-0 cursor-pointer w-50">
                          Version
                        </th>
                        <th class="p-0 cursor-pointer w-120" @click="toggleSortForUnselectedFormData('modifiedTime')">
                          Last Modified
                          <span class="sortUp" @click="sortUnselectedFormData('name', 'ASC')">
                            <i class="fa fa-angle-up" aria-hidden="true"></i>
                          </span>
                          <span class="sortDown" @click="sortUnselectedFormData('name', 'DESC')">
                            <i class="fa fa-angle-down" aria-hidden="true"></i>
                          </span>
                        </th>
                        <th class="p-0 w-25"></th>
                      </template>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(activity, index) in currentActivityList" :key="index" :class="activity.id === previewSelectedId ? 'preview-background-grey' : ''">
                      <td>
                        <img @click="closePreview" v-if="previewSelectedId === activity.id" src="static/img/surveyPreview/show.png" class="cursor-pointer ml-10" alt />
                        <img @click="openPreview(activity)" v-else src="static/img/surveyPreview/hide.png" class="cursor-pointer ml-10" alt />
                      </td>
                      <td class="activity-name ">
                        <span class="activity-name">
                          <router-link
                            class="color_4c8ce4"
                            v-if="activity.type == 'EDC'"
                            :to="{
                              name: 'study-form-view',
                              params: { formId: activity.id }
                            }"
                            >{{ activity.name }}
                          </router-link>
                          <div v-if="activity.type != 'EDC'">
                            {{ activity.name }}
                          </div>
                        </span>
                      </td>
                      <td class="activity-text activity_type mt-7 p-0">
                        <span>{{ activity.type | activityTypeName }}</span>
                      </td>
                      <template v-if="!previewSelectedId">
                        <td>
                          <div class="p-0 schedulemilestone" v-if="activity.frequency && activity.frequency != undefined">
                            <span>
                              {{ activity.frequency.title }}
                            </span>
                          </div>
                          <div class="p-0 schedulemilestone" v-else-if="activity.milestonesList && activity.milestonesList.length > 0">
                            <span v-for="(milestone, index) in getSortedMilestoneList(activity, 0, 1)" :key="index" :id="'form_' + activity.id + 'milestone_' + milestone.milestoneId">
                              {{ milestone.milestoneName }}
                              <b-tooltip :target="'form_' + activity.id + 'milestone_' + milestone.milestoneId">
                                <div v-for="(listOfMilestones, index) in studyData.milestonesList" :key="index">
                                  <span v-if="milestone.milestoneId === listOfMilestones.milestoneId">
                                    <span v-if="milestone.milestoneType && milestone.milestoneType == 'screening'">Screening Milestone {{ milestoneNum(listOfMilestones.milestoneId, "screening") }}</span>
                                    <span v-else>Milestone {{ milestoneNum(listOfMilestones.milestoneId, null) }}</span>
                                  </span>
                                </div>
                                <div>
                                  <span v-if="studyData.screeningMilestoneAllowed">Day {{ milestone.milestoneDay - studyData.screeningDuration }}</span>
                                  <span v-else>Day {{ milestone.milestoneDay }}</span>
                                </div>
                              </b-tooltip>
                            </span>
                            <button v-if="activity.milestonesList && activity.milestonesList.length > 1" variant="primary" class="btn show_milestones_plus_btn" size="lg" :id="`selected-${activity.id}-milestone`" tabindex="0">
                              +
                            </button>
                            <b-popover :target="`selected-${activity.id}-milestone`" triggers="click blur" placement="right" container="study-activity-activityId">
                              <div class="create-edit-packet-table__language-pop-over-container">
                                <ul class="create-edit-packet-table__languages-list">
                                  <li class="create-edit-packet-table__languages-list-item" v-for="(milestone, index) in getSortedMilestoneList(activity, 1, activity.length)" :key="index" :id="'form_' + activity.id + 'milestone_' + milestone.milestoneId">
                                    {{ milestone.milestoneName }}
                                  </li>
                                </ul>
                              </div>
                            </b-popover>
                          </div>
                          <div v-else-if="activity.activitySchedulingMode === 'onDemand'">
                            <span>
                              On-demand Only
                            </span>
                          </div>
                          <div v-else-if="activity.activitySchedulingMode === 'dynamicOnly'">
                            <span>
                              Dynamic Only
                            </span>
                          </div>
                          <button v-else variant="primary" class="schedule-btn-box" size="lg" @click="scheduleActivity(activity)">
                            <span class="schedule-btn-txt">Schedule</span>
                          </button>
                        </td>
                        <td class="p-0">
                          {{ activity.createdBy }}
                        </td>
                        <td class="p-0">
                          {{ activity.groupName }}
                        </td>
                        <td class="p-0">
                          {{ activity.stepsCount }}
                        </td>
                        <td class="p-0">
                          {{ activity.timeToComplete }}
                        </td>
                        <td class="p-0">
                          <span class="create-edit-packet-table__language-box" :id="`selected-${activity.activityId}-language`" tabindex="0">
                            {{ (activity.language && activity.language.length) || 0 }}
                          </span>
                          <b-popover :target="`selected-${activity.activityId}-language`" triggers="click blur" placement="left" container="study-activity-activityId">
                            <div class="create-edit-packet-table__language-pop-over-container" v-if="activity.language && activity.language.length">
                              <ul class="create-edit-packet-table__languages-list">
                                <li class="create-edit-packet-table__languages-list-item" v-for="(language, index) in activity.language" :key="index">
                                  {{ language.display_name }}
                                </li>
                              </ul>
                            </div>
                          </b-popover>
                        </td>
                        <td class="p-0">
                          <div class="position-relative">
                            <span class="create-edit-packet-table__language-box" @click="openVersionModal(activity)">
                              {{ activity.activityVersion || 1 }}
                            </span>
                            <span class="badge badge-pill badge-danger version-badge" v-if="activity.notificationCount">
                              {{ activity.notificationCount }}
                            </span>
                          </div>
                        </td>

                        <td>{{ getLastModifiedTime(activity) }}</td>
                        <td class="pr-20">
                          <div class="text-right">
                            <img src="static/img/activity-configurator/row-settings.svg" id data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" alt class="action-icon dropdown-toggle cursor-pointer" />
                            <ul class="dropdown-menu action-dropdown-menu p-0 dropleft">
                              <li href="#" class="border-bottom settings-dropdown-item fs-12">
                                <span v-if="activity.type == 'EDC'" class="dropdown-item pl-0 disabled">
                                  Create Copy
                                </span>
                                <span v-else @click.stop="createActivityCopy(activity, 'activity-details')" class="dropdown-item pl-0">Create Copy</span>
                              </li>
                              <li href="#" class="border-bottom settings-dropdown-item fs-12">
                                <span v-if="activity.type == 'EDC'" class="dropdown-item pl-0 disabled">
                                  Export JSON
                                </span>
                                <span v-else @click.stop="downloadObjectAsJson(activity.activityId, activity.revisionId)" class="dropdown-item pl-0">Export JSON</span>
                              </li>
                              <li href="#" class="border-bottom settings-dropdown-item fs-12">
                                <span v-if="activity.type == 'EDC'" class="dropdown-item pl-0 disabled">
                                  Export PDF
                                </span>
                                <span v-else @click.stop="exportActivityPdf(activity, 'study-activities-activity-export')" class="dropdown-item pl-0">Export PDF</span>
                              </li>
                              <li href="#" class="border-bottom settings-dropdown-item fs-12">
                                <span v-if="activity.type == 'EDC'" class="dropdown-item pl-0 disabled">
                                  Print Activity
                                </span>
                                <span v-else @click.stop="exportActivityPdf(activity, 'study-activities-activity-export')" class="dropdown-item pl-0">Print Activity</span>
                              </li>
                              <li href="#" class="border-bottom settings-dropdown-item fs-12" v-if="!activity.migrated">
                                <span @click.stop="reviseActivity(activity, 'activity-details')" class="dropdown-item pl-0">Revise</span>
                              </li>
                              <li href="#" class="border-bottom settings-dropdown-item fs-12">
                                <span class="dropdown-item pl-0" @click="openVersionModal(activity)">Versions</span>
                              </li>
                              <li class="border-bottom settings-dropdown-item fs-12">
                                <span @click="scheduleActivity(activity)" class="dropdown-item pl-0">Schedule </span>
                              </li>
                              <li class="border-bottom settings-dropdown-item fs-12">
                                <span @click.stop="setNotification(activity)" class="dropdown-item pl-0">
                                  Notifications
                                </span>
                              </li>
                              <li href="#" class="border-bottom settings-dropdown-item fs-12">
                                <span @click.stop="removeForm(activity)" class="dropdown-item pl-0">Remove</span>
                              </li>
                            </ul>
                          </div>
                        </td>
                      </template>
                    </tr>
                  </tbody>
                </table>
                <b-row class="pl-20 pt-20 pb-20" v-if="allActivities && allActivities.length">
                  <div
                    @click="prevPage"
                    class="arrow-icon cursor_pointer"
                    :class="{
                      disabledPagination: currentPage <= 1
                    }"
                  >
                    <i class="fa fa-angle-left fs-23"></i>
                  </div>
                  <div class="pagination">{{ currentPage }}</div>
                  <div class="pagination2">of {{ totalPages }}</div>
                  <div
                    @click="nextPage"
                    class="arrow-icon cursor_pointer"
                    :class="{
                      disabledPagination: currentPage >= totalPages
                    }"
                  >
                    <i class="fa fa-angle-right fs-23"></i>
                  </div>
                </b-row>
              </div>
            </template>
            <div v-else class="text-center fs-16 mb-20 p-20">
              No Activities found for this study.
            </div>
          </div>

          <div class="col-md-6 mb-25 pl-20 preview-activity  container-stylee float-right bg-white" v-if="previewSelectedId">
            <div class="row mb-15">
              <div class="col-md-3 device-view-btn" v-if="showStepView == true" @click="toggleStepView()"><img class="mr-5" src="static/img/surveyPreview/phone.png" />Device view</div>
              <!-- <div
                            class="col-md-3"
                            v-if=" showStepView == true"
                          >
                          </div> -->
              <div class="col-md-3 device-view-btn" v-if="showStepView == false" @click="toggleStepView()"><img class="mr-5" src="static/img/activity-configurator/device-step-preview.svg" />Step view</div>

              <div class="col-md-5 activity-data-name-preview" v-if="showStepView == true">
                {{ activityData.name }}
              </div>
              <div class="col-md-4 p-0" v-if="showStepView == true">
                <div class="row float-right">
                  <div class="col-md-6 pb-10">{{ activityData.stepsCount }}&nbsp;Screens</div>
                  <div v-if="activityData.timeToComplete" class="col-md-6 pb-10">{{ activityData.timeToComplete }}&nbsp;min</div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12" v-if="showStepView == true">
                <readOnlyQuestions class :questions="questionAnswers" :activityData="activityData"></readOnlyQuestions>
              </div>
              <div v-if="showStepView == false" class="col-md-12 device-view-preview">
                <deviceQuestionsViewLibrary
                  class
                  :questions="questionAnswers"
                  :activityData="activityData"
                  :intrupted="intrupted"
                  @resetIntrupt="intrupted = false"
                  @isProcessing="
                    val => {
                      isExporting = val;
                    }
                  "
                ></deviceQuestionsViewLibrary>
                <div v-if="isExporting" class="loader" @click="intrupted = true">
                  <div class="loader-container">
                    <p><b>Processing</b></p>
                    <i class="fa fa-spinner fa-spin"></i>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <hr />
      </div>
    </div>
    <div v-if="currentView != 'activity-order'" class="tableBg mb-25 wrapper position-relative">
      <b-row>
        <b-col cols="10" class="p-0">
          <h6>
            <b>
              Packets
              <span class="badge badge-secondary ml-5">{{ unscheduledPackets.length }}</span>
            </b>
          </h6>
        </b-col>
        <b-col cols="2" class="p-0 text-right">
          <b-form-select v-model="packetShowOption" :options="unScheduleFormOptions" class="mb-3 fs-12" size="sm" @change="showPackets" />
        </b-col>
      </b-row>
      <table v-if="unscheduledPackets && unscheduledPackets.length" class="tableBg2 create-edit-packet-page__order-table" style="width: 100%">
        <thead>
          <tr>
            <th class="p-0 w-25" width="3%"></th>
            <th class="p-0 w-220" width="25%">
              Name
              <span class="sortUp" @click="sortUnselectedFormData('formName', 'ASC')">
                <i class="fa fa-angle-up" aria-hidden="true"></i>
              </span>
              <span class="sortDown" @click="sortUnselectedFormData('formName', 'DESC')">
                <i class="fa fa-angle-down" aria-hidden="true"></i>
              </span>
            </th>
            <th class="p-0 w-230" width="21%">Scheduled</th>
            <th class="p-0 w-120" width="20%">
              Number of Forms
              <span class="sortUp" @click="sortUnselectedFormData('stepsCount', 'ASC')">
                <i class="fa fa-angle-up" aria-hidden="true"></i>
              </span>
              <span class="sortDown" @click="sortUnselectedFormData('stepsCount', 'DESC')">
                <i class="fa fa-angle-down" aria-hidden="true"></i>
              </span>
            </th>
            <th class="p-0 w-100" width="10%">
              Last Modified
              <span class="sortUp" @click="sortUnselectedFormData('createdBy', 'ASC')">
                <i class="fa fa-angle-up" aria-hidden="true"></i>
              </span>
              <span class="sortDown" @click="sortUnselectedFormData('createdBy', 'DESC')">
                <i class="fa fa-angle-down" aria-hidden="true"></i>
              </span>
            </th>
            <th class="p-0 w-25" width="3%"></th>
          </tr>
        </thead>
        <tr v-for="(packet, index) in currentPacketList" :key="index" class="pb-10">
          <td class="p-0"></td>
          <td class="form-name p-0">
            <label>
              <span class="form-name">
                <router-link
                  :to="{
                    name: 'study-create-edit-packet',
                    params: {
                      studyId: studyId,
                      packetId: packet.id,
                      packet: packet
                    }
                  }"
                >
                  <span class="activity-name">{{ packet.name }} </span>
                </router-link>
              </span>
            </label>
          </td>

          <td class="p-0">
            <div class="p-0 schedulemilestone" v-if="packet.frequency && packet.frequency != undefined">
              <span>
                {{ packet.frequency.title }}
              </span>
            </div>
            <div class="p-0" v-else-if="packet.milestonesList && packet.milestonesList.length > 0">
              <span v-for="(milestone, index) in getSortedMilestoneListPacket(packet)" :key="index" :id="'packet_' + packet.id + 'milestone_' + milestone.milestoneId">
                {{ milestone.milestoneName }}
                <span v-if="index + 1 < packet.milestonesList.length">,</span>

                <b-tooltip :target="'packet_' + packet.id + 'milestone_' + milestone.milestoneId">
                  <div>
                    <div v-for="(listOfMilestones, index) in studyData.milestonesList" :key="index">
                      <span v-if="milestone.milestoneId === listOfMilestones.milestoneId">Milestone {{ index + 1 }}</span>
                    </div>
                  </div>
                  <div>
                    <span>Day {{ milestone.milestoneDay }}</span>
                  </div>
                </b-tooltip>
              </span>
            </div>
            <div v-else-if="packet.activitySchedulingMode === 'onDemand'">
              <span>
                On-demand Only
              </span>
            </div>
            <button v-else variant="primary" class="schedule-btn-box" size="lg" @click="schedulePacket(packet)">
              <span class="schedule-btn-txt">Schedule</span>
            </button>
          </td>
          <td class="p-0">
            <b-col cols="6" class="form-text p-0 create-edit-packet-table__language-box" :id="`selected-${packet.id}-unscheduledForms`" tabindex="0" v-if="packet.unscheduledForms && packet.unscheduledForms.length > 0">{{ packet.unscheduledForms.length }}</b-col>
            <b-popover :target="`selected-${packet.id}-unscheduledForms`" triggers="click blur" placement="left" container="data-capture-formId">
              <div class="create-edit-packet-table__language-pop-over-container" v-if="packet.unscheduledForms && packet.unscheduledForms.length">
                <ul class="create-edit-packet-table__languages-list">
                  <li class="create-edit-packet-table__languages-list-item" v-for="(unscheduledForm, index) in packet.unscheduledForms" :key="index">
                    {{ unscheduledForm.formName }}
                  </li>
                </ul>
              </div>
            </b-popover>
          </td>
          <td class="p-0">{{ getLastModifiedTimeForPacket(packet) }}</td>
          <td class="p-0">
            <b-col cols="1" class="p-0 float-right">
              <div class="dropleft">
                <img src="static/img/activity-configurator/row-settings.svg" id data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" alt class="action-icon dropdown-toggle" />
                <ul class="dropdown-menu action-dropdown-menu p-0 dropleft">
                  <li class="border-bottom settings-dropdown-item fs-12">
                    <span @click.stop="copyPacket(packet)" class="dropdown-item pl-0">Create Copy</span>
                  </li>
                  <li class="border-bottom settings-dropdown-item fs-12">
                    <span @click.stop="editPacket(packet)" class="dropdown-item pl-0">Edit</span>
                  </li>
                  <li class="border-bottom settings-dropdown-item fs-12">
                    <span @click.stop="schedulePacket(packet)" class="dropdown-item pl-0">Schedule Packet</span>
                  </li>
                  <li href="#" class="border-bottom settings-dropdown-item fs-12">
                    <span @click.stop="removePacket(packet)" class="dropdown-item pl-0">Remove</span>
                  </li>
                </ul>
              </div>
            </b-col>
          </td>
        </tr>
      </table>

      <div v-else class="text-center fs-16 mb-15 p-20">
        No packets found for this study.
      </div>
      <b-row class="pt-20" v-if="unscheduledPackets && unscheduledPackets.length">
        <div @click="prevPacketPage" class="arrow-icon cursor_pointer" :class="{ disabledPagination: currentPacketPage <= 1 }">
          <i class="fa fa-angle-left fs-23"></i>
        </div>
        <div class="pagination">{{ currentPacketPage }}</div>
        <div class="pagination2">of {{ totalPacketPages }}</div>
        <div
          @click="nextPacketPage"
          class="arrow-icon cursor_pointer"
          :class="{
            disabledPagination: currentPacketPage >= totalPacketPages
          }"
        >
          <i class="fa fa-angle-right fs-23"></i>
        </div>
      </b-row>
    </div>
    <div id="activity-order" v-if="currentView == 'activity-order'">
      <div class="container-box">
        <ActivitiesOrder v-on:viewScheduleActivities="changeFromActivityOrder" :studyId="studyId" :studyData="studyData" />
      </div>
    </div>
    <div class="footerStyle">
      <div class="container">
        <div class="row footer-row" v-if="isStudySummary">
          <b-btn class="btn nextBtn float-left br-25" @click="cancelModify">Cancel modifying</b-btn>
          <b-btn class="btn br-25 disable-btn p-0 pt-5 mr-10" :to="{ name: 'study-summary', params: { studyId: studyId } }">Back to study summary</b-btn>
          <button class="btn br-25 continue-btn mr-10" v-on:click="nextClick()">
            Save and Continue
          </button>
        </div>
        <div class="row" v-if="!isStudySummary">
          <button class="btn br-25 disable-btn mr-10" v-on:click="skipForNow()">
            Skip for now
          </button>
          <button class="btn nextBtn br-25" v-on:click="nextClick()">
            Save and Continue
          </button>
        </div>
      </div>
    </div>
    <CancelModal ref="cancelConfirmation" />
    <ActivityVersionModal :activity-id="activityId" :revision-id="revisionId" :show-push-to-live="migrated" @close="closeVersionModal" @onViewModifications="openActivityComparator" @pushLive="openPushLiveConfirmationModal" />
    <b-modal ref="comparatorModal" size="1162" class="activity-comparator" scrollable :hide-footer="true" :hide-header="true" :no-close-on-backdrop="true">
      <header class="modal-header fs-16 bb-none text-black pl-0 pr-0 pt-0">
        <span class="modal-title">Modifications</span>
        <button type="button" class="close text-color" @click="closeComparatorModal">
          <i class="fa fa-times"></i>
        </button>
      </header>

      <comparator :source-activity-data="sourceActivityData" :target-activity-data="targetActivityData" :load-differences="loadActivityDiff" :hide-push-to-live="!migrated" :notification-count="notificationCount" :study-id="studyId" @pushLive="openPushLiveConfirmationModal" @updateCount="updateNotificationCount" />
    </b-modal>

    <b-modal ref="pushLiveConfirmationalModal" :hide-header="true" :hide-footer="true" size="sm">
      <b-row>
        <b-col class="p-0">
          <img src="static/img/add.svg" class="float-right close-icon" @click="closePushLiveConfirmationModal" />
        </b-col>
      </b-row>
      <div class="m-5">
        <b-row class="mb-15">
          <b-col align-self="center">
            <h5 class="text-center font-weight-bold">
              Are you sure you want to push this version live?
            </h5>
          </b-col>
        </b-row>
        <b-row class="mb-15">
          <b-col align-self="center">
            <h5 class="text-center">
              The modifications of Version
              {{ pushingActivity.version || 0 }} will replace the current version of this activity.
            </h5>
          </b-col>
        </b-row>
        <div class="pt-20 pb-15 text-center">
          <b-button variant="outline-secondary text-primary" class="px-5 mr-20" size="lg" @click="closePushLiveConfirmationModal">
            Cancel
          </b-button>
          <b-button variant="primary" size="lg" class="px-5" @click="pushVersionLive">
            Yes
          </b-button>
        </div>
      </div>
    </b-modal>
  </div>
</template>
<script>
import studyFeatureHeader from "../common/study-features-header";
import swal from "sweetalert2";
import toastr from "toastr";
import _ from "lodash";
import slice from "lodash/slice";
import ceil from "lodash/ceil";
import filter from "lodash/filter";
import readOnlyQuestions from "@/components/activity-library/activity-preview-read-only-questions";
import deviceQuestionsViewLibrary from "@/components/activity-library/activity-device-view-library";
import studyActivityCommon from "@/components/configurator/study-activities-mixin";

import ActivitiesOrder from "./activities-order";
import moment from "moment";
import CancelModal from "./cancel-modify-modal";
import ActivityVersionModal from "@/components/common/activity-version-modal";
import Comparator from "@/components/activity-library/activity-comparator/comparator";
import { mapGetters } from "vuex";

export default {
  name: "study-activities",
  components: {
    studyFeatureHeader,
    readOnlyQuestions,
    deviceQuestionsViewLibrary,
    ActivitiesOrder,
    CancelModal,
    ActivityVersionModal,
    Comparator
  },
  data() {
    return {
      studyId: this.$route.params.studyId,
      intrupted: false,
      allActivities: [],
      activities: [],
      formLists: [],
      participantActivities: [],
      siteActivities: [],
      selectedShowOption: 10,
      currentPage: 1,
      totalPages: 1,
      currentActivityList: [],
      selectedForms: [],
      scheduleFormOptions: [],
      unScheduleFormOptions: [],
      isExporting: false,
      sortMap: {
        formName: "ASC",
        type: null,
        createdBy: null,
        groupName: null,
        stepsCount: null,
        timeToComplete: null,
        modifiedTime: null
      },
      activityData: [],
      questionAnswers: [],
      previewSelectedId: null,
      showStepView: true,
      showDeviceButton: true,
      currentView: "scheduled-activities",
      formData: [],
      studyData: {},
      isStudySummary: true,
      unscheduledPackets: [],
      allUnscheduledPackets: [],
      currentPacketList: [],
      totalPacketPages: 1,
      packetShowOption: 10,
      searchTerm: "",
      activityId: null,
      revisionId: null,
      sourceActivityData: null,
      targetActivityData: null,
      loadActivityDiff: false,
      migrated: false,
      notificationCount: 0,
      pushingActivity: { version: 0 },
      getActivityObject: {}
    };
  },
  computed: {
    ...mapGetters(["user"])
  },
  mixins: [studyActivityCommon],
  mounted() {
    this.getAllActivities();
    this.getStudyDetails();
    setTimeout(() => {
      this.getUnscheduledPackets();
    }, 1200);
  },
  filters: {
    activityTypeName(value) {
      if (value == "PRO (Patient Reported Outcome)") {
        return "PRO";
      } else {
        return value;
      }
    }
  },
  methods: {
    milestoneNum(id, type) {
      let list;
      if (type) {
        list = this.studyData.milestonesList.filter(mile => mile.milestoneType);
      } else {
        list = this.studyData.milestonesList.filter(mile => !mile.milestoneType);
      }

      if (list && list.length < 0) {
        return;
      }
      const foundIndex = list.findIndex(mile => mile.milestoneId == id);
      if (foundIndex >= 0) {
        return foundIndex + 1;
      }
    },
    setNotification(activity) {
      const route = {
        name: "study-activity-set-notification",
        params: { formId: activity.id },
        query: { siteFacing: activity.siteFacing }
      };
      this.$router.push(route);
    },
    searchFormName(searchTerm) {
      if (searchTerm) {
        let search = searchTerm;
        search = search.trim();
        this.activities = this.allActivities;
        this.activities = filter(this.activities, form => form.name.toLowerCase().includes(search.toLowerCase()));
        this.showActivities(this.selectedShowOption);
        this.unscheduledPackets = this.allUnscheduledPackets;
        this.unscheduledPackets = filter(this.unscheduledPackets, packet => packet.name.toLowerCase().includes(search.toLowerCase()));
        this.showActivities(this.selectedShowOption);
        this.showPackets(this.packetShowOption);
      } else {
        this.activities = this.allActivities;
        this.unscheduledPackets = this.allUnscheduledPackets;
        this.showActivities(this.selectedShowOption);
        this.showPackets(this.packetShowOption);
      }
    },
    getUnscheduledPackets() {
      this.$api.getUnscheduledPacketNewFactV3(this.studyId).then(response => {
        this.allUnscheduledPackets = response.body;
        this.unscheduledPackets = this.allUnscheduledPackets;
        this.showPackets(this.packetShowOption);
      });
    },
    toggleStepView() {
      if (!this.showStepView) {
        this.showStepView = true;
      } else {
        this.showStepView = false;
      }
    },
    getStudyDetails() {
      this.$api.getStudyDataFact(this.studyId).then(response => {
        this.studyData = response.body;
      });
    },
    getSortedMilestoneList(activity, start, end) {
      const formClone = _.cloneDeep(activity);
      formClone.milestonesList.sort((a, b) => Number(a.sortOrder) - Number(b.sortOrder));
      return formClone.milestonesList.slice(start, end);
    },
    getSortedMilestoneListPacket(packet) {
      const packetClone = _.cloneDeep(packet);
      packetClone.milestonesList.sort((a, b) => Number(a.sortOrder) - Number(b.sortOrder));
      return packetClone.milestonesList;
    },
    showFormsForSelection() {
      const route = {
        name: "study-create-packet",
        params: {
          studyId: this.studyId
        }
      };
      this.$router.push(route);
    },
    selectActivityFromLibrary() {
      const route = {
        name: "study-activities-activity-library",
        params: {
          viewMode: true,
          studyId: this.studyId
        }
      };
      this.$router.push(route);
    },
    showPackets(packetShowOption) {
      this.totalPacketPages = ceil(this.unscheduledPackets.length / packetShowOption) === 0 ? 1 : ceil(this.unscheduledPackets.length / packetShowOption);
      this.selectedPackets = [];
      let start = 0;
      let end = packetShowOption;
      for (let index = 0; index < this.totalPacketPages; index++) {
        this.selectedPackets.push(slice(this.unscheduledPackets, start, end));
        start += packetShowOption;
        end += packetShowOption;
      }
      if (!this.unScheduleFormOptions || !this.unScheduleFormOptions.length) {
        for (let index = 1; index <= this.totalPages; index++) {
          this.unScheduleFormOptions.push({
            value: index * 10,
            text: `Show ${index * 10} items`
          });
        }
      }
      this.currentPacketPage = 1;
      this.currentPacketList = this.selectedPackets[this.currentPacketPage - 1];
    },
    prevPacketPage() {
      if (this.currentPacketPage <= this.totalPacketPages) {
        this.currentPacketPage -= 1;
        this.currentPacketList = this.selectedPackets[this.currentPacketPage - 1];
      }
    },
    nextPacketPage() {
      if (this.currentPacketPage < this.totalPacketPages) {
        this.currentPacketList = this.selectedPackets[this.currentPacketPage];
        this.currentPacketPage += 1;
      }
    },
    createActivity() {
      this.$router.push({
        name: "study-activities-activity-details",
        params: { activityId: 0, studyId: this.studyId }
      });
    },
    async getAllActivities() {
      await this.getParticipantFacingActivities();
      await this.getSiteFacingActivities();
      this.mergeActivities();
    },
    getParticipantFacingActivities() {
      return this.$api.getParticipantStudyActivitiesV2(this.studyId).then(response => {
        this.participantActivities = response.data;

        this.participantActivities.forEach((activity, index) => {
          activity.sequence = index;
        });
      });
    },
    getSiteFacingActivities() {
      return this.$api.getEDCFormsList(this.studyId).then(response => {
        this.siteActivities = response.data;
      });
    },
    mergeActivities() {
      this.allActivities = [...this.participantActivities, ...this.siteActivities];
      this.activities = this.allActivities.sort((a, b) => a.name - b.name);
      this.showActivities(this.selectedShowOption);
    },
    openPreview(activity) {
      this.previewSelectedId = activity.id;
      this.questionAnswers = [];
      this.activityData = {};
      this.$store.dispatch("activityQuestionsAction", this.questionAnswers);
      this.getActivityDetails(activity.activityId, activity.revisionId);
      this.showStepView = true;
    },
    closePreview() {
      this.previewSelectedId = null;
      this.showStepView = true;
    },
    getActivityDetails(activityId, revisionId) {
      this.$api.getActivityDetails(activityId, revisionId).then(
        response => {
          this.activityData = response.data.result;
          this.$store.dispatch("setActivityDetailsAction", response.data.result);
          if (this.activityData.questions && this.activityData.questions.length > 0) {
            this.questionAnswers = this.processQuestion(response.data.result.questions);
            this.$store.dispatch("activityQuestionsAction", this.questionAnswers);
          }
        },
        error => {
          this.errorMsg = error.body ? error.body.message : "Error while getting activity details";
          toastr.error(this.errorMsg);
        }
      );
    },
    processQuestion(question) {
      question.map(function(value) {
        if (value.type == "SurveyInstruction") {
          if (value.formattedTitle == "") {
            value.formattedTitle = value.title;
          }
          if (value.formattedInformation == "") {
            value.formattedInformation = value.information;
          }
        } else if (value.type == "CustomScale" && value.formattedLabels == undefined) {
          value.formattedLabels = value.labels;
        } else {
          if (value.formattedBody == "") {
            value.formattedBody = value.body;
          }
          if (value.options !== undefined && value.options.formattedBody == "") {
            value.options.formattedBody = value.options.body;
          }
        }
      });
      return question;
    },
    createActivityCopy(activity, path) {
      this.$router.push({
        name: path,
        params: {
          activityId: activity.activityId || activity.id,
          revisionId: activity.revisionId,
          studyId: this.studyId,
          mode: "copy"
        },
        query: { revisionId: activity.revisionId, mode: "copy" }
      });
    },
    downloadObjectAsJson(activityId, revisionId) {
      toastr.success("Activity file export in progress. Download will begin momentarily.");
      this.$api.getActivityDetails(activityId, revisionId || activityId).then(response => {
        const activityData = response.data.result;
        const dataStr = "data:text/json;charset=utf-8," + encodeURIComponent(JSON.stringify(activityData));
        const downloadAnchorNode = document.createElement("a");
        downloadAnchorNode.setAttribute("href", dataStr);
        downloadAnchorNode.setAttribute("download", "export_" + activityId + ".json");
        document.body.appendChild(downloadAnchorNode); // required for firefox
        downloadAnchorNode.click();
        downloadAnchorNode.remove();
      });
    },
    exportActivityPdf(activity, path) {
      this.$router.push({
        name: path,
        params: {
          activityId: activity.activityId,
          revisionId: activity.revisionId,
          studyId: this.studyId
        }
      });
    },
    reviseActivity(activity, path) {
      if (activity.type == "EDC") {
        this.$router.push({
          name: "study-activities-configure-new-form",
          params: {
            formId: activity.id,
            studyId: this.studyId,
            taskId: activity.id
          }
        });
      } else {
        this.$router.push({
          name: path,
          params: {
            activityId: activity.activityId,
            revisionId: activity.revisionId,
            studyId: this.studyId,
            taskId: activity.id,
            mode: "revise"
          },
          query: {
            revisionId: activity.revisionId,
            mode: "revise"
          }
        });
      }
    },
    async scheduleActivity(activity) {
      if (activity.type == "EDC") {
        this.$router.push({
          name: "study-schedule-form",
          params: {
            studyId: this.studyId,
            formId: activity.id,
            activityId: activity.activityId,
            isLegacy: false
          },
          query: { revisionId: activity.revisionId, type: activity.type }
        });
      } else {
        const isSiteFacing = await this.determineActivityFacing(activity);
        this.currentView = "activity-schedule";
        if (isSiteFacing) {
          this.$router.push({
            name: "study-schedule-form",
            params: {
              studyId: this.studyId,
              formId: activity.id,
              activityId: activity.activityId,
              isLegacy: false
            },
            query: { revisionId: activity.revisionId, type: activity.type }
          });
        } else {
          this.$router.push({
            name: "schedule-study-activity",
            params: { studyId: activity.studyId, surveyId: activity.id }
          });
        }
      }
    },
    removeForm(activity) {
      swal({
        title: "Are you sure you want to remove this form from your study?",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#b8c7ce",
        cancelButtonColor: "#f16559",
        confirmButtonText: "Cancel",
        cancelButtonText: "Yes"
      }).then(({ dismiss }) => {
        if (dismiss === "cancel") {
          if (activity.siteFacing) {
            this.$api
              .removeFormV3(activity.id, this.studyId)
              .then(() => {
                toastr.success("Form removed successfully");
                const index = this.currentActivityList.findIndex(element => element.id === activity.id);
                this.currentActivityList.splice(index, 1);
              })
              .catch(error => {
                const errorMsg = error.body ? error.body.message : "Error while removing Form";
                toastr.error(errorMsg);
              });
          } else {
            this.$api
              .removeParticipantActivityFromStudy(activity.id, this.studyId)
              .then(() => {
                toastr.success("Activity removed successfully");
                const index = this.currentActivityList.findIndex(element => element.id === activity.id);
                this.currentActivityList.splice(index, 1);
              })
              .catch(error => {
                const errorMsg = error.body ? error.body.message : "Error while removing Activity";
                toastr.error(errorMsg);
              });
          }
        }
      });
    },
    prevPage() {
      if (this.currentPage <= this.totalPages) {
        this.currentPage -= 1;
        this.currentActivityList = this.selectedForms[this.currentPage - 1];
      }
    },
    nextPage() {
      if (this.currentPage < this.totalPages) {
        this.currentActivityList = this.selectedForms[this.currentPage];
        this.currentPage += 1;
      }
    },
    showActivities(selectedShowOption) {
      this.totalPages = ceil(this.activities.length / selectedShowOption) === 0 ? 1 : ceil(this.activities.length / selectedShowOption);
      this.selectedForms = [];
      let start = 0;
      let end = selectedShowOption;
      for (let index = 0; index < this.totalPages; index++) {
        this.selectedForms.push(slice(this.activities, start, end));
        start += selectedShowOption;
        end += selectedShowOption;
      }
      if (!this.scheduleFormOptions || !this.scheduleFormOptions.length) {
        for (let index = 1; index <= this.totalPages; index++) {
          this.scheduleFormOptions.push({
            value: index * 10,
            text: `Show ${index * 10} items`
          });
        }
      }
      this.currentPage = 1;
      const allActivities = this.selectedForms[this.currentPage - 1];
      this.currentActivityList = allActivities;
    },
    toggleSortForUnselectedFormData(columnName) {
      if (this.sortMap[columnName] == null || this.sortMap[columnName] == "DESC") {
        this.sortMap[columnName] = "ASC";
      } else {
        this.sortMap[columnName] = "DESC";
      }

      this.sortUnselectedFormData(columnName, this.sortMap[columnName]);
    },
    sortUnselectedFormData(columnName, order) {
      this.sortMap[columnName] = order;
      let columnType = "string";
      if (columnName == "questionCount" || columnName == "timeToComplete") {
        columnType = "number";
      }
      if (columnName == "modifiedTime") {
        columnType = "date";
      }
      if (columnType == "string") {
        this.sortByString(columnName, order);
      } else if (columnType == "number") {
        this.sortByNumber(columnName, order);
      } else if (columnType == "date") {
        this.sortByDate(columnName, order);
      }
      this.showActivities(this.selectedShowOption);
      this.$forceUpdate();
    },
    sortByString(columnName, order) {
      if (order == "ASC") {
        this.activities.sort((a, b) => {
          const nameA = a[columnName] && a[columnName].toLowerCase();

          const nameB = b[columnName] && b[columnName].toLowerCase();
          if (nameA < nameB) {
            //sort string ascending
            return -1;
          }
          if (nameA > nameB) {
            return 1;
          }
          return 0;
        });
      } else {
        this.activities.sort((a, b) => {
          const nameA = a[columnName] && a[columnName].toLowerCase();

          const nameB = b[columnName] && b[columnName].toLowerCase();
          if (nameA < nameB) {
            return 1;
          }
          if (nameA > nameB) {
            return -1;
          }
          return 0;
        });
      }
    },
    sortByDate(columnName, order) {
      if (order == "ASC") {
        this.activities.sort((a, b) => {
          const dateA = new Date(a[columnName] && a[columnName]);

          const dateB = new Date(b[columnName] && b[columnName]);
          return dateA - dateB;
        });
      } else {
        this.activities.sort((a, b) => {
          const dateA = new Date(a[columnName] && a[columnName]);

          const dateB = new Date(b[columnName] && b[columnName]);
          return dateB - dateA;
        });
      }
    },
    getLastModifiedTime(activity) {
      if (activity.modifiedTime) {
        const modifiedTimeMoment = moment(activity.modifiedTime, "YYYY-MM-DD HH:mm:ss");
        return modifiedTimeMoment.format("D MMM YYYY");
      }
      return "";
    },
    getLastModifiedTimeForPacket(packet) {
      if (packet.modifiedAt) {
        const modifiedTimeMoment = moment(packet.modifiedAt, "DD-MMM-YYYY HH:mm:ss");
        return modifiedTimeMoment.format("D MMM YYYY");
      }
      return "";
    },
    sortByNumber(columnName, order) {
      if (order == "ASC") {
        this.activities.sort((a, b) => {
          return a[columnName] - b[columnName];
        });
      } else {
        this.activities.sort((a, b) => {
          return b[columnName] - a[columnName];
        });
      }
    },
    changeActivityOrder() {
      this.currentView = "activity-order";
    },
    changeFromActivityOrder() {
      this.getAllActivities();
      this.currentView = "scheduled-activities";
    },
    cancelModify() {
      this.$refs.cancelConfirmation.show();
    },
    nextClick() {
      const selectedFeatures = this.$store.getters.getSelectedFeatures;

      const featureIndex = _.findIndex(selectedFeatures, ["route", this.$route.name]);

      if (featureIndex === selectedFeatures.length - 1) {
        this.$router.push({ name: "features-library-final" });
      } else {
        this.$router.push({
          name: selectedFeatures[featureIndex + 1].route,
          params: { studyId: this.studyId }
        });
      }
    },
    copyPacket(packet) {
      const route = {
        name: "study-create-edit-packet",
        params: {
          studyId: this.studyId,
          packetId: packet.id,
          packet: packet,
          mode: "copy"
        }
      };
      this.$router.push(route);
    },
    editPacket(packet) {
      this.$router.push({
        name: "study-create-edit-packet",
        params: { studyId: this.studyId, packetId: packet.id }
      });
    },
    schedulePacket(packet) {
      this.$router.push({
        name: "study-schedule-packet",
        params: { studyId: this.studyId, packetId: packet.id },
        query: { taskType: packet.unscheduledForms[0].type }
      });
    },
    removePacket(packet) {
      swal({
        title: "Are you sure you want to remove this packet from your study?",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#b8c7ce",
        cancelButtonColor: "#f16559",
        confirmButtonText: "Cancel",
        cancelButtonText: "Yes"
      }).then(({ dismiss }) => {
        if (dismiss === "cancel") {
          this.$api
            .removePacketV3(packet.id)
            .then(() => {
              toastr.success("Packet removed successfully");
              this.getUnscheduledPackets();
            })
            .catch(error => {
              const errorMsg = error.body ? error.body.message : "Error while removing packet";
              toastr.error(errorMsg);
            });
        }
      });
    },

    openVersionModal(activity) {
      this.getActivityObject = activity;
      this.revisionId = activity.revisionId;
      this.activityId = activity.activityId;
      this.migrated = activity.migrated;
      this.notificationCount = activity.notificationCount;
    },

    closeVersionModal() {
      this.activityId = null;
      this.revisionId = null;
    },

    async openActivityComparator(sourceActivity, targetActivity) {
      this.sourceActivityData = sourceActivity;
      this.targetActivityData = targetActivity;
      this.loadActivityDiff = true;

      this.$nextTick(() => {
        this.$refs.comparatorModal.show();
      });
    },

    closeComparatorModal() {
      this.$refs.comparatorModal.hide();
      this.setDefaultDataForComparator();
    },

    async openPushLiveConfirmationModal(activity, hasActivityType = false) {
      try {
        if (!hasActivityType) {
          const activityResponse = await this.$api.getActivityDetails(activity.id, activity.revisionId);
          const activityData = activityResponse.data.result;
          activity.isSitefacing = this.determineActivity(activityData);
          activity.therapeuticArea = activityData.therapeuticArea;
          activity.therapeuticIndication = activityData.therapeuticIndication;
          activity.s3object_key = activityData.s3object_key;
          activity.type = activityData.type;
        }
        this.pushingActivity = activity;
        this.$refs.pushLiveConfirmationalModal.show();
        this.closeVersionModal();
      } catch (error) {
        const errorData = error.body || error;
        const errorMsg = errorData.message ? error.message : "Error while getting activity details.";
        this.$toastr.error(errorMsg);
      }
    },

    closePushLiveConfirmationModal() {
      this.setDefaultDataForComparator();
      this.$refs.pushLiveConfirmationalModal.hide();
    },

    setDefaultDataForComparator() {
      this.sourceActivityData = null;
      this.targetActivityData = null;
      this.loadActivityDiff = false;
      this.migrated = false;
      this.notificationCount = 0;
    },

    pushVersionLive() {
      if (this.pushingActivity.isSitefacing) {
        // Site team activity call
        this.pushSiteActivityLive(this.pushingActivity);
      } else {
        // Participant activity call
        this.pushParticipantActivityLive(this.pushingActivity);
      }
    },

    async pushSiteActivityLive(activity) {
      try {
        const formId = this.getActivityObject.id;
        const payload = (({ id, activityId, revisionId, name, type }) => ({
          id,
          activityId,
          revisionId,
          name,
          type
        }))(activity);
        payload.studyId = this.studyId;
        payload.id = this.getActivityObject.id;

        const notificationStatusUpdatePayload = {
          revisionId: activity.revisionId,
          viewedBy: this.user.id
        };

        const activityId = activity.activityId;
        const studyId = this.studyId;

        await this.$api.pushEdcFormVersionLive(formId, this.studyId, payload);
        this.$toastr.success("Pushed activity version live.");

        await this.$api.markNotificationStatusAsRead(studyId, activityId, notificationStatusUpdatePayload);

        this.getAllActivities();
      } catch (error) {
        const errorMsg = error.body ? error.body.message : "Error while pushing activity version live.";
        this.$toastr.error(errorMsg);
      } finally {
        this.closePushLiveConfirmationModal();
      }
    },

    async pushParticipantActivityLive(activity) {
      try {
        const formId = this.getActivityObject.id;
        const payload = (({ activityId, revisionId, timeToComplete, therapeuticArea, therapeuticIndication }) => ({
          activityId,
          revisionId,
          timeToComplete,
          therapeuticArea,
          therapeuticIndication
        }))(activity);

        payload.studyId = this.studyId;
        payload.title = activity.name;
        payload.s3Key = activity.s3object_key;
        payload.id = this.getActivityObject.id;
        payload.timeToComplete = this.getActivityObject.timeToComplete;

        const notificationStatusUpdatePayload = {
          revisionId: activity.revisionId,
          viewedBy: this.user.id
        };

        const activityId = activity.activityId;
        const studyId = this.studyId;

        await this.$api.pushParticipantFormLive(formId, this.studyId, payload);
        this.$toastr.success("Pushed activity version live.");

        await this.$api.markNotificationStatusAsRead(studyId, activityId, notificationStatusUpdatePayload);

        this.getAllActivities();
      } catch (error) {
        const errorMsg = error.body ? error.body.message : "Error while pushing activity version live.";
        this.$toastr.error(errorMsg);
      } finally {
        this.closePushLiveConfirmationModal();
      }
    },
    updateNotificationCount(responseObject) {
      const currentActivityIndex = this.currentActivityList.findIndex(activity => activity.activityId === responseObject.activityId);

      this.currentActivityList[currentActivityIndex].notificationCount = responseObject.notificationCount;
    }
  }
};
</script>

<style scoped lang="scss">
.schedulemilestone span:nth-child(3) span {
  display: none;
}
.create-edit-packet-page__order-table td a {
  position: relative;
  top: 5px;
  white-space: nowrap;
  width: 175px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: inline-block;
}
.create-edit-packet-page__order-table td a:hover {
  overflow: visible;
  white-space: nowrap;
  height: auto;
}
.show_milestones_plus_btn {
  width: 26px;
  height: 24px;
  border-radius: 4px;
  border: 1px solid #d3dee3;
  background-color: #fff;
  color: #00f;
  padding: 0;
  line-height: 20px;
}

.cursor-pointer {
  cursor: pointer !important;
}
.preview-background-grey {
  background-color: rgba(211, 223, 228, 0.6);
}
.sortUp {
  position: absolute;
  margin-top: -3px;
  padding-left: 4px;
  width: 0;
  height: 0;
  background: transparent;
  border-top-width: 0;
  cursor: pointer;
}
.sortDown {
  position: relative;
  padding-left: 4px;
  width: 0;
  height: 0;
  cursor: pointer;
  top: 5px;
  z-index: 1;
}
.tableBg {
  background-color: #ffffff !important;
  padding: 24px 20px 14px 20px !important;
  border-radius: 4px;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.06);
}
.container-style {
  border-radius: 3px;
  background-color: #ffffff;
  box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.1);
}

.container-box {
  border-radius: 3px;
  background-color: #ffffff;
  box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.1);
}
</style>
<style lang="scss">
.btnBgColor {
  border-radius: 4px;
  border: solid 1px #4c8ce4;
  background-color: #ffffff;
  font-size: 12px;
  letter-spacing: normal;
  color: #4c8ce4;
}
.create-activity {
  background-color: #1e8fe1;
  height: 35px;
  line-height: 16px;
}
.create-activity-img {
  position: relative;
  right: 10px;
  bottom: 5px;
}
.create-activity-text {
  position: relative;
  bottom: 3px;
}

.arrow-icon {
  width: 25px;
  height: 25px;
  border-radius: 3px;
  background-color: #ffffff;
  border: solid 1px #e4e8eb;
  text-align: center;
  font-size: 23px;
  line-height: 10px !important;
  color: #e4e8eb;
}

.pagination {
  width: 30px;
  height: 25px;
  border-radius: 3px;
  background-color: #ffffff;
  border: solid 1px #e4e8eb;
  text-align: center;
  font-size: 13px;
  line-height: 23px !important;
  color: #4a4a4a;
  padding-left: 11px !important;
}

.pagination2 {
  width: 40px;
  height: 25px;
  background-color: #ffffff;
  font-size: 13px;
  line-height: 23px !important;
  color: #4a4a4a;
  padding-left: 6px !important;
}

.disabledPagination {
  pointer-events: none;
}

.schedule-btn-txt {
  font-size: 12px;
  color: #4c8ce4;
}

.schedule-btn-box {
  background-color: white;
  border-radius: 3px;
  border: solid 1px #4c8ce4;
  height: 22px;
  cursor: pointer;
}

.action-dropdown-menu {
  line-height: 27px;
  font-size: 12px;
  padding: 0.125rem 0.75rem;
  box-shadow: rgba(0, 0, 0, 0.1) 1px 1px 1px 1px;
  min-width: 7rem;
}

.dropleft .dropdown-toggle::before {
  border-right: 0 !important;
  transform: rotate(45deg);
  background-color: #4c8ce4;
}

.settings-dropdown-item {
  line-height: 27px;
  font-size: 12px;
  padding: 0.125rem 0.75rem;
  cursor: pointer;
}

.create-edit-packet-page {
  &__order-table {
    tr {
      height: 41px;
      border-bottom: 1px solid #d3dfe4;
    }
  }

  &__add-activities-table {
    tr {
      height: 41px;
      border-bottom: 1px solid #d3dfe4;
    }

    input[type="checkbox"] {
      // display: none;
      height: 21px;
      width: 21px;
    }
  }

  &__order-table,
  &__add-activities-table {
    th {
      font-family: "RobotoRegular";
      font-size: 12px;
      font-weight: bold;
      font-stretch: normal;
      font-style: normal;
      line-height: 2.18;
      letter-spacing: normal;
      color: #b0bac9;
    }

    td {
      font-size: 12px;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: 16px;
      letter-spacing: normal;
      color: #000000;
    }

    .activity_type {
      font-size: 12px;
      font-weight: bold;
      font-stretch: normal;
      font-style: normal;
      overflow: hidden;
      text-overflow: clip;
      width: 50px;
      line-height: 2;
      letter-spacing: normal;
      color: #000000;
    }
  }
}

.create-edit-packet-table {
  &__language-box {
    width: 35px;
    height: 24px;
    font-size: 14px;
    font-weight: bold;
    color: #4c8ce4;
    border: 1px solid #d3dee3 !important;
    border-radius: 4px;
    text-align: center;
    display: inline-block;
    cursor: pointer;
    line-height: 22px;

    &:focus {
      outline: none;
    }
  }

  &__language-pop-over-container {
    box-shadow: 0 4px 10px 0 rgba(0, 0, 0, 0.15);
    background-color: #ffffff;
    overflow-y: scroll;
    max-height: 258px;
    scrollbar-width: thin; /* "auto" or "thin"  */
    scrollbar-color: #e6e9ed transparent; /* scroll thumb & track */

    &::-webkit-scrollbar {
      width: 5px; /* width of the entire scrollbar */
      max-height: 15%;
    }
    &::-webkit-scrollbar-track {
      background: transparent; /* color of the tracking area */
    }
    &::-webkit-scrollbar-thumb {
      background-color: #b0bac9; /* color of the scroll thumb */
      border-radius: 20px; /* roundness of the scroll thumb */
      border: 3px solid transparent; /* creates padding around scroll thumb */
    }
  }

  &__languages-list {
    list-style: none;
    padding: 0 15px 0 10px;
    padding-top: 9px;
  }

  &__languages-list-item {
    font-size: 14px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 2.14;
    letter-spacing: normal;
    color: #000000;
  }
}

#study-activity-activityId .popover {
  width: auto !important;
  margin: 0 !important;
  box-shadow: 0 4px 10px 0 rgba(0, 0, 0, 0.15);
  background-color: #ffffff;
  left: -8px !important;
  border: none;

  .popover-body {
    margin: 0 !important;
    padding: 0 !important;
  }
}

.activity-name {
  font-size: 13px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.33;
  letter-spacing: normal;
  color: #1e8fe1;
  word-break: break-word;
}

.preview-background-grey {
  background-color: rgba(211, 223, 228, 0.6);
}

.primaryBackGround {
  background-color: #ffffff !important;
  padding: 0px 20px 20px 20px !important;
  width: 100% !important;
  border-radius: 4px;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.06);
}

#activity-versions .nav {
  background: #fff;
  border-bottom: 1px solid #d4dfe4;
}

#activity-versions .nav-bar {
  .nav-link {
    color: #2d3752 !important;
    padding: 26px 20px 9px;
    border-bottom: 4px solid transparent;

    &.active {
      font-weight: 600;
      border-bottom-color: #4c8ce4;
    }
  }
}

.create-activity {
  background-color: #1e8fe1;
  height: 35px;
  line-height: 16px;
}

.create-activity-img {
  position: relative;
  right: 10px;
  bottom: 5px;
}

.create-activity-text {
  position: relative;
  bottom: 3px;
}

.badge-container {
  font-size: 12px;
}
.badge-secondary {
  background-color: #b0bac9;
  position: relative;
  bottom: 2px;
}

.btn {
  font-size: 14px;
}

.footer-row {
  display: block;
}
.device-view-btn {
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.33;
  letter-spacing: normal;
  color: #4c8ce4;
  cursor: pointer;
  z-index: 90;
}
.loader {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background-color: #ffffffa1;
  z-index: 99;
}
.loader .loader-container {
  margin: auto;
  text-align: center;
  vertical-align: middle;
  margin-top: calc(50vh - 30px);
  border: 0px solid;
  width: 118.4px;
  height: 118.4px;
  padding: 15px 15px 15px 15px;
  border-radius: 4px;
  -webkit-box-shadow: 0 4px 10px 0 rgba(0, 0, 0, 0.45);
  box-shadow: 0 4px 10px 0 rgba(0, 0, 0, 0.45);
  background-color: #ffffff;
}
.loader .loader-container .fa.fa-spin {
  font-size: 3em;
}
.loader .fa-spinner {
  font-size: 24px;
  color: #4c8ce4;
}
.noOfForms {
  color: #f16559;
}
.schedulemilestone {
  white-space: nowrap;
}
.wrapper {
  width: 100%;
  height: 100%;
  padding: 0;
}
.schedulemilestone span {
  white-space: nowrap;
  max-width: 176px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: inline-block;
  margin-right: 7px;
  top: 5px;
  position: relative;
}
@media only screen and (min-width: 320px) and (max-width: 767px) {
  .select-library {
    display: flex;
  }
  .btn {
    white-space: nowrap !important;
  }
  .wrapper {
    overflow: auto;
  }
}
.disabled {
  cursor: not-allowed;
  opacity: 0.5;
}
.version-badge {
  position: absolute;
  bottom: 14px;
  right: 10px;
  font-size: 8px;
}
.activity-comparator {
  .modal {
    .modal-header {
      .close {
        opacity: 1;
        padding: 0.75rem 0.75rem 1rem 1rem;
      }
    }
  }
}
.close-icon {
  cursor: pointer;
  opacity: 0.7;
}
.close-icon:hover {
  opacity: 1;
}
.box-slider .vue-box-select li {
  margin: 0 1% !important;
  position: relative;
  display: inline-block;
  text-align: center;
}
.act-step-box-slider .vue-box-select li {
  display: inline-block;
  margin: 0 8px !important;
}
</style>
